import { forwardRef } from 'react';
import moment from 'moment';
import IcComment from '../../../assets/image/community/ic_comment.svg';

interface PostCardProps {
  post: any;
  onClick: (id: number) => void;
}

const PostCard = forwardRef<HTMLButtonElement, PostCardProps>(({ post, onClick }, ref) => {
  return (
    <button
      type="button"
      className="w-full flex flex-col items-start justify-between p-4 pl-0 border-b border-gray-200 hover:bg-gray-50"
      onClick={() => onClick(post?.id)}
      ref={ref}
    >
      <img
        src={post?.coverUrl}
        alt="event-image"
        className="w-full h-[180px] object-cover rounded-[8px] mb-2"
      />
      <div className="text-left mb-3">
        <div className="font-[700] text-[16px]">{post.title}</div>
      </div>
      <div className="w-full flex justify-between items-center">
        <div className="text-[12px] font-[400] text-[#969696]">
          {moment(post.createdAt).format('YY.MM.DD')}
        </div>
        <div className="flex justify-end items-center">
          <img src={IcComment} alt="chevron right" className="w-[18px] h-[18px]" />
          <span className="ml-1 text-[#969696] text-[12px]">{post.commentCount}</span>
        </div>
      </div>
    </button>
  );
});

export default PostCard;
